"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var customerListActions = require("@caddigital/sok-reducers/lib/actions/customer/list");
var reliablePartnerSettings = require("@caddigital/sok-reducers/lib/actions/bid/reliablePartnerSettings");
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function () {
        return dispatch(customerListActions.fetchCustomerListRequest('NORMAL', {
            includeProjects: true,
            includeEmployees: true,
            includeFederation: true
        }));
    },
    toggleModal: function () { return dispatch(reliablePartnerSettings.toggleModal()); },
    clear: function () { return dispatch(reliablePartnerSettings.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
